const breakpointMap: Record<string, number> = {
  xxl: 1300,
  xl: 1200,
  lg: 992,
  md: 820,
  sm: 576,
  xs: 0,
};

const breakpointMapV2: Record<string, number> = {
  sm: 480,
  md: 768,
  lg: 1024,
  xlg: 1280,
  xxl: 1600,
};

export const isBreakpoint = (breakpoint: string) => {
  return window.innerWidth <= breakpointMap[breakpoint];
};

export const isBreakpointV2 = (breakpoint: string) => {
  return window.innerWidth <= breakpointMapV2[breakpoint];
};
